import { useNavigate } from 'react-router-dom';
import { useGetSubscriptionPlansQuery } from '../slices/subscriptionsApiSlice';

const SubscriptionPlan = () => {
    const navigate = useNavigate();
    const { data: plans, isLoading, isError, error } = useGetSubscriptionPlansQuery();

    // ローディング中のUI表示
    if (isLoading) return <div>Loading...</div>;
    // エラーがあった場合のUI表示
    if (isError) return <div>Error: {error.message}</div>;

    const handleSelectPlan = (id) => {
        // サブスクリプション選択処理（例: サーバーに保存）
        navigate(`/subscription/${id}/join`); // 次の画面へのナビゲート
    };
    // カスタムIDマッピング（plan.idに基づいて名前を割り当て）
    const getCustomPlanName = (planId, index) => {
        // インデックスベースで名前を割り当て（または plan.id に基づいてマッピング）
        const customNames = ['LIGHT', 'STANDARD', 'PREMIUM'];
        return customNames[index] || `plan-${index + 1}`;
    };

    return (
        <div className="subscriptionplan-container">
            <div className="subscriptionplan-content">
                <h1 className="subscriptionplan-content-title">
                    サブスクで古着を<br />
                    もっと楽しもう
                </h1>
                <div className="subscriptionplan-content-grid">
                    {plans.map((plan, index) => {
                        const customPlanName = getCustomPlanName(plan.id, index);
                        const isFirst = index === 0;
                        const isLast = index === plans.length - 1;
                        
                        return (
                            <div className="subscriptionplan-content-grid-wrapper" key={plan.id}>
                                {/* すべてのカードにラベルエリアを確保（STANDARDは空） */}
                                <div className="subscriptionplan-content-grid-wrapper-label">
                                    {isFirst && '＼古着初心者さんにおすすめ／'}
                                    {isLast && '＼古着好きさんにおすすめ／'}
                                    {!isFirst && !isLast && '\u00A0'}
                                </div>
                                <div className={`subscriptionplan-content-grid-wrapper-card subscriptionplan-content-grid-wrapper-card--${customPlanName.toLowerCase()}`}>
                                    {customPlanName === 'STANDARD' && (
                                        <div className="subscriptionplan-content-grid-wrapper-card-badge">
                                            一番<br/>
                                            人気
                                        </div>
                                    )}
                                    <div className={`subscriptionplan-content-grid-wrapper-card-header subscription-content-grid-wrapper-card-header--${customPlanName.toLowerCase()}`}>
                                        <h2>{customPlanName}</h2>
                                    </div>
                                    <div className="subscriptionplan-content-grid-wrapper-card-body">
                                        <div className="subscriptionplan-content-grid-wrapper-card-body-text">
                                            <p className="subscriptionplan-content-grid-wrapper-card-body-text-title">料金</p>
                                            <p className={`subscriptionplan-content-grid-wrapper-card-body-text-price--${customPlanName.toLowerCase()}`}>¥{plan.price}<span className="subscription-content-grid-wrapper-card-body-text-price-small">/月(税込)</span></p>
                                            <p className="subscriptionplan-content-grid-wrapper-card-body-text-title">借りられる古着の上限定価金額</p>
                                            <p className={`subscriptionplan-content-grid-wrapper-card-body-text-price--${customPlanName.toLowerCase()}`}>¥{plan.itemPriceLimit}</p>
                                            <p className="subscriptionplan-content-grid-wrapper-card-body-text-description">
                                            {plan.maxItems}着が何度でも交換可能
                                            </p>
                                        </div>
                                        <button 
                                            className="subscriptionplan-content-grid-wrapper-card-body-button" 
                                            onClick={() => handleSelectPlan(plan.id)}
                                        >
                                            詳細

                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default SubscriptionPlan;